<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-row>
              <gmap-map
                :center="mapCentre"
                :zoom="mapZoom"
                style="width:100%;  height: 450px;"
                ref="mapRef"
                @zoom_changed="zoom_changed"
                @bounds_changed="bounds_changed"
              >
                <gmap-info-window
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen=false"
                ></gmap-info-window>
                <gmap-marker
                  :key="'marker' + index"
                  v-for="(m, index) in markers"
                  @click="toggleInfoWindow(m,index)"
                  v-on:mouseover="toggleInfoWindow(m,index)"
                  :position="m.position"
                  :clickable="m.clickable != null ? m.clickable : true"
                  :draggable="m.clickdraggableable != null ? m.draggable : true"
                  :icon="m.icon"
                ></gmap-marker>
                <gmap-polyline
                  :key="'path' + index"
                  v-for="(path, index) in paths"
                  v-show="path.length > 0"
                  :path="path.coordinates"
                  :editable="path.editable"
                  @path_changed="updateEdited($event)"
                  @rightclick="handleClickForDelete"
                  ref="polyline"
                  :options="{'strokeColor':path.strokeColor}"
                ></gmap-polyline>
              </gmap-map>
              <div style="width:100%;position: absolute;" v-if="showSearch">
                <gmap-autocomplete @place_changed="setPlace" :label="$i18n.t('Seach Location')"></gmap-autocomplete>
              </div>
              <div
                style="top:-275px; width:50px;position:relative; margin:auto"
                v-if="showCentreMarker"
              >
                <v-icon style="font-size: 50px;" color="red">mdi-map-marker</v-icon>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  props: {
    markers: {
      default: () => [],
    },
    lines: {
      default: () => [],
    },
    center: {
      type: Object,
      default() {
        return { lat: 27.508, lng: 77.587 };
      },
    },
    zoom: {
      default: 12,
    },
    showSearch: {
      default: true,
    },
    showCentreMarker: {
      default: false,
    },
  },
})
export default class GoogleMap extends Vue {
  map = null;
  mapCentre = this.center;
  mapZoom = this.zoom;
  paths = [];
  currentPlace = null;
  infoWindowPos = null;
  infoWinOpen = false;
  currentMidx = null;

  zoom_changed(zoom) {
    const bound = {
      lat1: this.map.getBounds().getNorthEast().lat(),
      lat2: this.map.getBounds().getSouthWest().lat(),
      lon1: this.map.getBounds().getNorthEast().lng(),
      lon2: this.map.getBounds().getSouthWest().lng(),
    };
    this.$emit("zoom_changed", bound);
  }

  bounds_changed(zoom) {
    const bound = {
      lat1: this.map.getBounds().getNorthEast().lat(),
      lat2: this.map.getBounds().getSouthWest().lat(),
      lon1: this.map.getBounds().getNorthEast().lng(),
      lon2: this.map.getBounds().getSouthWest().lng(),
    };
    this.$emit("bounds_changed", bound);
  }

  infoOptions = {
    content: "",
    //optional: offset infowindow so it visually sits nicely on top of our marker
    pixelOffset: {
      width: 0,
      height: -35,
    },
  };

  toggleInfoWindow(marker, idx) {
    this.infoWindowPos = marker.position;
    this.infoOptions.content = marker.infoText;

    //check if its the same marker that was selected if yes toggle
    if (this.currentMidx == idx) {
      this.infoWinOpen = !this.infoWinOpen;
    }
    //if different marker set infowindow to open and reset current marker index
    else {
      this.infoWinOpen = true;
      this.currentMidx = idx;
    }
  }

  updateEdited(mvcPath) {
    // this.mvcPath = mvcPath;
  }

  updateCenter(place) {
    this.mapCentre = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
  }

  handleClickForDelete($event) {
    // if ($event.vertex) {
    //   this.$refs.polyline.$polylineObject
    //     .getPaths()
    //     .getAt($event.path)
    //     .removeAt($event.vertex);
    // }
  }

  @Watch("center")
  onCenteChange() {
    this.mapCentre = {
      lat: parseFloat(this.center.lat),
      lng: parseFloat(this.center.lng),
    };
  }
  @Watch("zoom")
  onZoomChange() {
    this.mapZoom = parseFloat(this.zoom);
  }

  @Watch("lines")
  onLinesChange() {
    this.populatePaths();
  }

  populatePaths() {
    this.paths = [];
    if (this.lines && this.lines.length > 0) {
      for (let i = 0; i < this.lines.length; i++) {
        const path = {
          coordinates: CommonUtil.decodePolyline(this.lines[i].line),
        };
        path.editable = this.lines[i].editable;
        path.strokeColor = this.lines[i].strokeColor
          ? this.lines[i].strokeColor
          : "green";
        this.paths.push(path);
      }
    }
  }

  get loading() {
    return common.loading;
  }

  async mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
    this.populatePaths();
    console.log("Google Map Mounted");
  }

  setPlace(place) {
    this.currentPlace = place;
    this.mapCentre = place.geometry.location;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>